import { useState } from "react";
import { api, imgUrl } from "@/lib/api";
import { Upload, Loader2, ImageIcon } from "lucide-react";
import { toast } from "sonner";

export function ImageUpload({ value, onChange, label = "Image", testid = "image-upload", aspect = "aspect-video" }) {
  const [uploading, setUploading] = useState(false);

  const handle = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/upload", fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      onChange(data.url);
      toast.success("Image uploaded");
    } catch {
      toast.error("Upload failed. Please try a JPG/PNG under 8MB.");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div>
      <p className="text-sm font-semibold mb-1.5">{label}</p>
      <label
        data-testid={testid}
        className={`relative block ${aspect} w-full rounded-xl border-2 border-dashed border-stone-300 overflow-hidden cursor-pointer hover:border-primary transition-colors bg-muted`}
      >
        {value ? (
          <img src={imgUrl(value)} alt="preview" className="h-full w-full object-cover" />
        ) : (
          <div className="h-full w-full grid place-items-center text-muted-foreground">
            <div className="text-center">
              <ImageIcon className="h-6 w-6 mx-auto mb-1" />
              <span className="text-xs">Tap to upload</span>
            </div>
          </div>
        )}
        <div className="absolute bottom-2 right-2 bg-primary text-white rounded-full h-9 w-9 grid place-items-center shadow">
          {uploading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Upload className="h-4 w-4" />}
        </div>
        <input type="file" accept="image/*" className="hidden" onChange={handle} disabled={uploading} />
      </label>
    </div>
  );
}
